import { render, staticRenderFns } from "./internet.vue?vue&type=template&id=0316b43d&lang=pug"
import script from "./internet.vue?vue&type=script&lang=js"
export * from "./internet.vue?vue&type=script&lang=js"
import style0 from "./internet.vue?vue&type=style&index=0&id=0316b43d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports